var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BarChartDisplay"},[_c('Card',{attrs:{"title":_vm.title}},[(_vm.isVisible)?_c('barChart',{staticClass:"BarChart",attrs:{"width":500,"type":"bar","options":_vm.options,"series":_vm.series}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }